// animations.ts
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

export const Animations = {
    fadeInOut: trigger(
        'enterAnimation', [
          transition(':enter', [
            style({opacity: 0}),
            animate('500ms', style({opacity: 1}))
          ]),
          transition(':leave', [
            style({opacity: 1}),
            animate('500ms', style({opacity: 0}))
          ])
        ]
      ),
    fade: trigger('fade', [
        state('false', style({ opacity: 0 })),
        state('true', style({ opacity: 1 })),
        transition('* <=> *', animate(1))
      ])
}